import { Resource } from "./resource";
import { Ajax } from "../helpers/ajax";

export interface LoaderCallback
{
    (response:any):any
}

class LoaderTask
{
    public static readonly EMPTY:number = 0;
    public static readonly WAITING:number = 1;
    public static readonly RUNNING:number = 2;
    public static readonly DONE:number = 3;
    public static readonly ERROR:number = -1;

    public status:number = LoaderTask.EMPTY;

    constructor (public url:string, public onload:LoaderCallback, public onerror:LoaderCallback, public flags:number){}
}

export class Loader
{   
    // How many load tasks can be performed simultaneously
    public static simultaneous:number = 64;     
    
    public static readonly TYPE_ANY:number = 0;
    public static readonly TYPE_JSON:number = 1;
    public static readonly TYPE_IMAGE:number = 2;    

    private static queue:LoaderTask[] = [];
    private static activeTasks:number = 0;
    
    // Call this from main update loop
    public static Update()
    {
        this.advanceQueue();
    }

    public static Load(url:string, onload:LoaderCallback = null, onerror:LoaderCallback = null, flags:number = Loader.TYPE_ANY)
    {        
        let task:LoaderTask = new LoaderTask(url, onload, onerror, flags);
        
        this.enqueue(task);
    }

    private static enqueue(t:LoaderTask)
    {
        this.queue.push(t);
        t.status = LoaderTask.WAITING;
    }

    private static advanceQueue()
    {
        while (this.activeTasks < this.simultaneous && this.queue.length > 0)        
        {
            let t:LoaderTask = this.queue.splice(0,1)[0];
            this.runTask(t);            
        }
    }

    private static runTask(t:LoaderTask)
    {
        this.activeTasks++;
        t.status = LoaderTask.RUNNING;

        if ((t.flags & Loader.TYPE_JSON) > 0)
        {
            Ajax.getJSON(t.url, 
            (response) => 
            {
                if (t.onload != null) t.onload(response);
                t.status = LoaderTask.DONE;
                this.activeTasks--;
            }, 
            (error) =>
            {
                if (t.onerror != null) t.onerror(error);
                t.status = LoaderTask.ERROR;
                this.activeTasks--;
            });
        }            
        else
        {
            Ajax.get(t.url, 
            (response) => 
            {
                if (t.onload != null) t.onload(response);
                t.status = LoaderTask.DONE;
                this.activeTasks--;
            }, 
            (error) =>
            {
                if (t.onerror != null) t.onerror(error);
                t.status = LoaderTask.ERROR;
                this.activeTasks--;
            });
        }
    }
}